import React from 'react'
import { Field } from 'react-final-form'
import styled from 'styled-components'
import { IntlProvider } from 'react-intl'

import { useRequest } from '../hooks/request'
import { VARIANT_SECONDARY } from '../constants/variants'
import { forgotPassword, forgotPasswordPath } from '../requests/forgotPassword'

import { PageTitle } from './common/PageTitle'
import { Form } from './common/Form'
import { Button } from './common/Button'
import { Menu } from './common/Typography'
import { InputField } from './fields/InputField'

export const ForgotPassword = () => {
  const forgotPasswordRequest = useRequest({
    request: forgotPassword,
  })
  const messages = {
    connect: 'Se connecter',
    forgotPasswordSuccess: 'Si ce compte existe, un email vient de lui être envoyé.',
    forgotPassword: 'Mot de passe oublié ?',
    email: 'Adresse e-mail',
    emailPlaceholder: 'E-mail...',
    'validation.required': 'Ce champ est obligatoire',
    confirm: 'Confirmer',
    'should match pattern "[a-zA-Z0-9\\._%+!$&*=^|~#%{}/\\-]+@([a-z0-9\\-]+\\.){1,}([a-z]{2,22})"': 'Doit être un email',
  }

  return (
    <IntlProvider locale="fr" messages={messages}>
      <Wrapper>
        <InnerWrapper>
          <PageTitle tradId="forgotPassword" />
          {
            forgotPasswordRequest.state.success ? (
              <Menu tradId="forgotPasswordSuccess" />
            ) : (

              <Form path={forgotPasswordPath} onSubmit={forgotPasswordRequest.fetch}>
                {({ handleSubmit, form }) => (
                  <>
                    <Field required component={InputField} name="email" label="email" placeholder="emailPlaceholder" />
                    <Button
                      fullWidth
                      onClick={handleSubmit}
                      loading={form.getState().submitting}
                      tradId="confirm"
                      filled
                      variant={VARIANT_SECONDARY}
                    />
                  </>
                )}
              </Form>
            )
          }
        </InnerWrapper>
      </Wrapper>
    </IntlProvider>
  )
}


const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const InnerWrapper = styled.div`
  
`
